import React, { ReactElement } from 'react';
import DOMPurify from 'dompurify';
import { Col, Heading, Row } from 'idsk-react-components';
import './informacieOCookies.scss';

interface Props {
  text: string | null | undefined
}

const InformacieOCookies = (
  { text }
    : Props,
): ReactElement => (
  <div className="informacie-o-cookies">
    <Heading size="xl">Informácie o cookies</Heading>
    {text && (
      <Row className="informacie-o-cookies-main__row">
        <Col className="informacie-o-cookies-main__col" width="two-thirds">
          <>
            {/* eslint-disable-next-line react/no-danger */}
            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }} />
          </>
        </Col>
      </Row>
    )}
  </div>

);

export default InformacieOCookies;
